<template>
  <b-modal
    id="modal-promo"
    ref="promo-modal"
    title="Создание/Редактирование шаблона промокодов"
    ok-only
    ok-title="Сохранить"
    @ok="updateTemplate"
  >
    <b-form-group
      label="Название шаблона"
      class="mt-1 mb-0"
    >
      <b-form-input
        v-model="template.name"
        placeholder="Название шаблона"
        required
        class="inline-block"
      />
    </b-form-group>
    <div
      v-for="(promo, i) in template.promos"
      :key="'template.promos_' + i"
      class="mt-2"
    >
      <div>
        <span class="promo-item">Промокод {{ i + 1 }}</span>
        <b-button
          title="Удалить"
          variant="flat-danger"
          class="btn-icon inline-block"
          size="sm"
          @click="template.promos.splice(i, 1)"
        >
          <feather-icon icon="MinusIcon" />
        </b-button>
      </div>
      <b-form-group
        label="Промокод"
        class="mt-1 mb-0"
      >
        <b-form-input
          v-model="promo.code"
          placeholder="Промокод"
          class="inline-block"
        />
      </b-form-group>
      <b-form-group
        label="Скидка"
        class="mt-1 mb-0"
      >
        <b-form-checkbox
          :checked="promo.percent === false"
          switch
          class="custom-control-primary mb-1"
          @change="value => changeDiscountType(promo, value)"
        >
          Скидка в рублях
        </b-form-checkbox>
        <b-form-input
          v-if="promo.percent !== false"
          v-model.number="promo.value"
          type="number"
          no-wheel
          placeholder="Размер скидки в %"
          class="inline-block"
        />
        <price-input-wrapper
          v-else
          :value="promo.value"
          placeholder="Размер скидки в рублях"
          @input="value => (promo.value = value)"
        />
      </b-form-group>
      <b-form-group
        label="Срок действия"
        class="mt-1 mb-0"
      >
        <flat-pickr
          v-model="promo.expiresAt"
          placeholder="Срок действия"
          class="form-control inline-block"
          :config="dateConfig"
        />
      </b-form-group>
      <b-form-group
        label="Лимит использований"
        class="mt-1 mb-0"
      >
        <b-form-input
          v-model.number="promo.usageLimitInitial"
          type="number"
          no-wheel
          placeholder="Лимит использований"
          class="inline-block"
        />
      </b-form-group>
    </div>
    <b-button
      class="mt-1"
      variant="primary"
      size="small"
      @click="addPromo"
    >Добавить промокод
    </b-button>
  </b-modal>
</template>

<script>
import {
  VBPopover, BButton, BFormInput, BFormGroup, BFormCheckbox,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PriceInputWrapper from '@/global-components/PriceInputWrapper.vue'
import crudModule from '@/libs/crud_module'

const promoModule = crudModule({
  entity_name: 'promocode-template',
})

export default {
  name: 'PromoTemplateModal',
  components: {
    BFormInput,
    BButton,
    BFormGroup,
    BFormCheckbox,
    flatPickr,
    PriceInputWrapper,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  props: {
    template: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dateConfig: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
      },
    }
  },
  watch: {
    'template.promos': {
      handler(promos) {
        this.normalizePromos(promos)
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    addPromo() {
      this.template.promos.push({
        code: null,
        value: null,
        percent: true,
        expiresAt: null,
        usageLimitInitial: null,
      })
    },
    normalizePromos(promos) {
      if (!Array.isArray(promos)) return

      promos.forEach(promo => {
        if (promo.percent === undefined) {
          this.$set(promo, 'percent', true)
        }

        if (promo.expiresAt === undefined) {
          this.$set(promo, 'expiresAt', null)
        }
      })
    },
    changeDiscountType(promo, isRubles) {
      this.$set(promo, 'percent', !isRubles)
      this.$set(promo, 'value', null)
    },
    updateTemplate(bvModalEvent) {
      if (!this.template.name) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Заполните поля',
            icon: 'BellIcon',
            text: 'Введите название шаблона',
            variant: 'danger',
          },
        })

        bvModalEvent.preventDefault()
        return
      }

      const promosWithError = this.template.promos.filter(promo => !promo.code || !promo.value)
      if (promosWithError.length !== 0) {
        promosWithError.forEach(promo => {
          if (!promo.code) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Заполните поля',
                icon: 'BellIcon',
                text: 'В промокоде необходимо указать название',
                variant: 'danger',
              },
            })
          } else if (!promo.value) {
            const discountUnit = promo.percent === false ? 'в рублях' : 'в %'
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Заполните поля',
                icon: 'BellIcon',
                text: `В промокоде ${promo.code} необходимо указать 'Размер скидки ${discountUnit}' `,
                variant: 'danger',
              },
            })
          }
        })
        bvModalEvent.preventDefault()
        return
      }

      if (this.template.id) {
        this.saveTemplate()
      } else {
        this.createTemplate()
      }
    },
    async saveTemplate() {
      await promoModule.updateItem(this.template.id, {
        name: this.template.name,
        instances: this.template.promos,
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Уведомление',
            icon: 'BellIcon',
            text: 'Шаблон сохранен',
            variant: 'success',
          },
        })
        this.$refs['promo-modal'].hide()
        this.$emit('update')
      }).catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Уведомление',
            icon: 'BellIcon',
            text: error.response.data.message,
            variant: 'danger',
          },
        })
      })
    },
    async createTemplate() {
      await promoModule.createItem({
        name: this.template.name,
        instances: this.template.promos,
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Уведомление',
            icon: 'BellIcon',
            text: 'Шаблон создан',
            variant: 'success',
          },
        })
        this.$refs['promo-modal'].hide()
        this.$emit('update')
      }).catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Уведомление',
            icon: 'BellIcon',
            text: error.response.data.message,
            variant: 'danger',
          },
        })
      })
    },
  },
}
</script>
<style scoped lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.promo-item {
    font-size: 16px;
    font-weight: 500;
}
</style>
